import { browserHistory } from "react-router";
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import RemarksModal from 'template/Modals/Remarks'
import React, { PropTypes } from 'react';
import TransactionSummaryModal from 'template/Modals/TransactionSummary'
import __R, { userCan } from 'containers/__R'

export default function() {

	return [
    {
      title: __('Remarks', 'classdetail'),
      hasAlert: ({ trData })=>{
        return trData.trRemark && trData.trRemark.length > 0;
      },
      onClick: ({trData: financeInfo})=>{
        RemarksModal({id: financeInfo.id, type:'finance'})
        .then((res) => {
          this.fetchTradeRecord();
        })
      },
			isDisabled: (opts) => {
				return !userCan('edit_trade_record_note')
			}
    },
    {
      title: __('Send', 'finance'),
      onClick: ({trData: financeInfo})=>{
				TransactionSummaryModal({
					id: financeInfo.id,
					student: financeInfo.student_name,
					transaction_number: financeInfo.transaction_number,
					operator_name: financeInfo.operator_name,
					student_email: financeInfo.student_email
				})
      },
			isDisabled: (opts) => {
				return !userCan('send_trade_record_email')
			}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/containers/tables/FinanceTable/table-settings.js